/** Corporate center detail / edit / info / manage pages (en) */
export default {
	shared: {
		merchantCat: {
			c1: "Taoist temple",
			c2: "Buddhist temple",
			c3: "Church",
			c4: "Meditation",
			c5: "Mind-body healing",
			c6: "Spiritual practice",
			c7: "Psychological counseling",
		},
		businessStatus: {
			normal: "Open",
			paused: "Suspended",
		},
		auditStatus: {
			auditing: "Under review",
			approved: "Approved",
			rejected: "Rejected",
			pendingSubmit: "Pending submission",
		},
		phoneMobile: "Mobile",
		phoneLand: "Landline",
	},
	detail: {
		index: {
			missingMerchantId: "Missing institution ID",
			loadFailed: "Failed to load data",
			loadFailedRetry: "Failed to load data. Please try again.",
			loadErrorTitle: "Failed to load data",
		},
		pc: {
			loading: "Loading...",
		},
		m: {
			follow: "Follow",
			videoContent: "Video",
			tabCover: "Cover",
			tabVideo: "Video",
			tabAlbum: "Album",
			altCover: "Cover",
			altAlbum: "Album",
			managerTitle: "Manager",
			map: "Map",
			phone: "Phone",
			businessHoursTitle: "Business hours",
			orgIntroTitle: "About",
			introImageAlt: "About",
			featuredServicesTitle: "Featured services",
			bookNowAria: "Book now",
		},
	},
	edit: {
		meta: {
			breadcrumb: "Edit institution",
		},
		breadcrumbMy: "My institutions",
		breadcrumbEdit: "Edit institution",
		tabBasic: "Basic information",
		tabQualification: "Qualifications",
		missingMerchantId: "Missing institution ID",
		updating: "Updating...",
		updateSuccess: "Updated successfully",
		updateFailed: "Update failed. Please try again.",
		saving: "Saving...",
		saveSuccess: "Saved locally",
		saveFailed: "Save failed. Please try again.",
		loadFailed: "Failed to load data",
		loadFailedRetry: "Failed to load data. Please try again.",
		mNavTitle: "Institution onboarding",
		mCancel: "Cancel",
		mSave: "Save",
	},
	info: {
		meta: {
			breadcrumb: "Institution details",
		},
		breadcrumbMy: "My institutions",
		breadcrumbDetail: "Institution details",
		tabBasic: "Basic information",
		tabQualification: "Qualifications",
		missingMerchantId: "Missing institution ID",
		loadFailed: "Failed to load data",
		loadFailedRetry: "Failed to load data. Please try again.",
		mNavTitle: "Institution onboarding",
		basic: {
			sectionBasic: "Basic information",
			edit: "Edit",
			orgName: "Institution name",
			orgNameEn: "English name",
			category: "Category",
			businessStatus: "Business status",
			businessHours: "Business hours",
			thDay: "Day",
			thTime: "Hours",
			emptyHours: "No business hours",
			contactPhone: "Phone",
			thType: "Type",
			thNumber: "Number",
			emptyPhone: "No phone numbers",
			sectionAddress: "Address",
			country: "Country / region",
			addressInfo: "Address line",
			address: "Address",
			addressEn: "Address (English)",
			coordinates: "Coordinates",
			sectionMedia: "Media",
			coverTitle: "Profile image",
			imagesTitle: "Photos",
			videosTitle: "Videos",
			imgAltOrg: "Institution image",
			emptyMedia: "No media",
			sectionDetail: "Details",
			labelTraditional: "Traditional Chinese",
			labelEnglish: "English",
			sectionManager: "Manager",
			managerPhoto: "Manager photo",
			managerPhotoAlt: "Manager photo",
			noPhoto: "No photo",
			managerIntro: "Introduction",
			managerIntroEn: "Introduction (English)",
			sectionServices: "Featured services",
			serviceImgAlt: "Service image",
			noServiceImg: "No image",
			pricePrefix: "Price: ",
			emptyServices: "No featured services",
		},
		qualification: {
			title: "Qualifications",
			orgName: "Institution name",
			orgNameEn: "English name",
			orgAddress: "Address",
			certificate: "Registration certificate",
			certificateAlt: "Registration certificate",
			noCertificate: "No certificate",
			managerName: "Manager name",
			managerContact: "Manager contact",
			modalTitle: "Registration certificate",
		},
	},
	manage: {
		meta: {
			breadcrumb: "My institutions",
		},
		breadcrumbMy: "My institutions",
		tabInstitution: "Institutions",
		tabOrder: "Orders",
		orderSectionTitle: "Orders",
		institutionSectionTitle: "Institutions",
		query: "Search",
		reset: "Reset",
		joinEntry: "Join",
		colOrgName: "Name",
		colCategory: "Category",
		colAudit: "Review status",
		colBusiness: "Business status",
		colAddress: "Address",
		colActions: "Actions",
		editNow: "Edit",
		manageAction: "Manage",
		empty: "No data",
		mNavInstitution: "My institutions",
		mNavOrder: "Orders",
		fetchFailed: "Failed to load data",
		orderPc: {
			filterOrderTime: "Order time",
			startTime: "Start",
			endTime: "End",
			filterStatus: "Order status",
			all: "All",
			filterNickname: "User nickname",
			placeholderNickname: "Enter nickname",
			colOrderNo: "Order no.",
			colOrderTime: "Order time",
			colOrderStatus: "Status",
			colNickname: "Nickname",
			colProduct: "Product",
			colAmount: "Amount",
			colReceipt: "Received",
			colPayTime: "Paid at",
			colRefund: "Refund",
			none: "None",
			empty: "No data",
			totalRecords: "{n} records in total",
			refundModalTitle: "Refund details",
			refundApplicant: "Applicant:",
			refundApplyTime: "Applied at:",
			refundReason: "Reason:",
			refundAmount: "Amount:",
			refundStatus: "Status:",
			refundTime: "Refunded at:",
			orderStatusUnpaid: "Unpaid",
			orderStatusPaid: "Paid",
			orderStatusClosed: "Closed",
			orderStatusRefunded: "Refunded",
			orderStatusRefunding: "Refunding",
			unknown: "Unknown",
			fetchOrderFailed: "Failed to load orders",
			refundSucceeded: "Refund succeeded",
			refundFailed: "Refund failed",
			refundPending: "Processing",
			refundRejected: "Rejected",
			refundDetailFailed: "Failed to load refund details",
		},
		orderM: {
			filterOrderTime: "Order time",
			startPlaceholder: "Start",
			to: "to",
			endPlaceholder: "End",
			filterStatus: "Order status",
			all: "All",
			filterNickname: "User nickname",
			placeholderNickname: "Enter nickname",
			query: "Search",
			reset: "Reset",
			finishedText: "No more",
			empty: "No data",
			statusAll: "All",
			statusUnpaid: "Unpaid",
			statusPaid: "Paid",
			statusClosed: "Closed",
			statusReviewed: "Reviewed",
			statusRefunded: "Refunded",
			statusRefunding: "Refunding",
			unknown: "Unknown",
			fetchFailed: "Failed to load orders",
			yearSuffix: " ",
			monthSuffix: "/",
			daySuffix: "",
		},
		orderCard: {
			unknownUser: "Unknown user",
			unknownService: "Unknown service",
			actualReceipt: "Received:",
			refundAmount: "Refund:",
			orderNo: "Order no.:",
			copy: "Copy",
			orderTime: "Ordered:",
			payTime: "Paid:",
			none: "None",
			orderNoEmpty: "Order number is empty",
			copyUnsupported: "Copy is not supported",
			copySuccess: "Copied",
			copyFailed: "Copy failed",
		},
		institutionCard: {
			auditLabel: "·Review",
			businessLabel: "·Business",
			manage: "Manage",
			approvalTitle: "Approval details",
			editNow: "Edit now",
			cancel: "Cancel",
			approvalResult: "Result",
			approved: "Approved",
			rejected: "Rejected",
			approvalComment: "Comment",
		},
	},
};
